import { Component, NgZone, OnInit } from '@angular/core';
import * as MagnoliaConfigActions from '../../../../store/actions/magnolia-config.actions';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getSelectedProductAvailableSettingsError,
  getSelectedProductAvailableSettingsLoaded,
  getSelectedProductDetails,
  getSettingsCategoriesConfig,
} from '../../../../store/reducers';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { combineLatest } from 'rxjs';
import {
  getOnlySettingCategoriesProcessed,
  getTealiumLocation,
  Option,
  OptionCategory,
  Product,
} from '@dch/products-business-logic';
import { WebshopUtils } from '../../../../shared/webshop/webshop-utils';
import {
  CustomerService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import {
  getAlertKey,
  onResult,
} from '../../../../shared/order-utils/order-utils';
import {
  AlertsService,
  ModalService,
  PxModalMessageService,
} from '@proximus/ng-common-components';
import { DetailsUtilService } from '../../../details-service.utils';

@Component({
  selector: 'mprd-available-settings-container',
  templateUrl: './available-settings-container.component.html',
  styleUrls: ['./available-settings-container.component.css'],
})
export class AvailableSettingsContainerComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  availableSettingsLoaded: boolean;
  selectedProduct: Product;
  hasError: boolean;
  tealiumLocation: string;
  categories: Array<OptionCategory>;
  isEBU: boolean;
  isURKidsCardSubscribed = false;
  private isSubscribed: boolean;
  private fakeSettingForAlert: Option = {
    optionCodeForDescription: 'AIA_PENDING',
  } as Option;

  constructor(
    private store: Store<ApplicationState>,
    private languageService: LanguageService,
    private translationService: TranslationService,
    private modalService: ModalService,
    private alertsService: AlertsService,
    private ngZone: NgZone,
    private pxModalMessageService: PxModalMessageService,
    private customerService: CustomerService,
    private readonly detailsUtilService: DetailsUtilService,
  ) {
    super();
  }

  ngOnInit() {
    this.store.dispatch(
      new MagnoliaConfigActions.GetSettingsCategoriesConfig(),
    );

    this.addSubscription(
      this.store
        .select(getSelectedProductAvailableSettingsError)
        .subscribe((value) => {
          this.hasError = !!value;
        }),
    );
    this.addSubscription(
      combineLatest([
        this.store.select(getSettingsCategoriesConfig),
        this.store.select(getSelectedProductDetails),
        this.store.select(getSelectedProductAvailableSettingsLoaded),
        this.customerService.getCustomerAccount(),
      ]).subscribe((res) => {
        const config = res[0];
        const selectedProduct = res[1];
        this.availableSettingsLoaded = res[2];
        const customerAccount = res[3];
        this.isEBU = customerAccount.isEBU();
        if (this.isEBU === false) {
          this.isURKidsCardSubscribed = this.detailsUtilService.isKidsCardProduct(
            selectedProduct?.mobileProductDetails?.groupMpcUuid,
          );
        }
        if (
          config &&
          selectedProduct &&
          JSON.stringify(this.selectedProduct) !==
            JSON.stringify(selectedProduct.mobileProductDetails) &&
          this.availableSettingsLoaded
        ) {
          this.selectedProduct = selectedProduct.mobileProductDetails;
          this.tealiumLocation = getTealiumLocation(
            this.selectedProduct as any,
          );
          const optionCategoriesProcessed = getOnlySettingCategoriesProcessed(
            this.selectedProduct,
            config,
            this.languageService.getSelectedLanguage(),
            undefined,
          );
          this.categories = optionCategoriesProcessed.categories;
          if (this.isEBU === false) {
            this.subscribeToWebshopEvents();
            WebshopUtils.publishCartRetrival(
              this.selectedProduct.installationId,
              this.selectedProduct.accessNumber,
              this.selectedProduct.plc,
            );
          }
        }
      }),
    );
  }

  getAlertKey() {
    return getAlertKey(undefined, this.fakeSettingForAlert);
  }

  private subscribeToWebshopEvents() {
    if (!this.isSubscribed) {
      this.isSubscribed = true;
      WebshopUtils.subscribeToCartEvent((data: any) => {
        this.ngZone.run(() => {
          if (data.status === 'PENDING_ORDER') {
            onResult(
              {
                type: 'warning',
                action: 'aiaPending',
              },
              undefined,
              undefined,
              this.fakeSettingForAlert,
              this.translationService,
              this.languageService,
              this.modalService,
              this.pxModalMessageService,
              this.alertsService,
            );
          }
        });
      }, this.addSubscription);
    }
  }
}
